import React, { useState } from "react";
import { Button, Modal, Row, Divider, Col, Space, DatePicker, Spin } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import columnsCase90 from "../data/Columns_Case90";
import TablePCMoble from "../data/Table_PC_Moble";
import { main_wdr } from "../api/apiCent90";
import { exportFinanceReportPDF } from "../pdf/ExportFinanceReportPDF";
import { FileTextOutlined } from "@ant-design/icons";


/**
 * ModalPrintFinanceReport
 * ปุ่ม "รายงานรับฝากค่างวด ตามรอบ" กดแล้วเปิด modal ให้เลือกรอบ (ช่วงวันที่) แล้วแสดงตาราง
 * ยังไม่มี API/รูปแบบรายงานที่แน่ชัดสำหรับพิมพ์จริง ตอนนี้ดึงข้อมูลจาก main_wdr มาแสดงก่อน
 */
function ModalPrintFinanceReport() {
  const [open, setOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(dayjs()); // เดือน/ปีที่เลือก (ค่าเริ่มต้น = เดือนปีปัจจุบัน)
  const [roundType, setRoundType] = useState("round1"); // "round1" = 13-26, "round2" = 27-12 (ค่าเริ่มต้น = round1)
  const [dataMainS4, setDataMainS4] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await axios.post(main_wdr, {
        statuses: [3, 4, 5 ],
        user: "admin888",
        flagHdpayment: true,
      });
      console.log("res.data", res.data);
      setDataMainS4(res.data.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setOpen(true);
    loadData();
  };
  const handleClose = () => setOpen(false);

  // รอบ 1: 13-26 ของเดือนที่เลือก / รอบ 2: 27 เดือนที่เลือก - 12 เดือนถัดไป
  const getRange = () => {
    if (!selectedMonth || !roundType) return null;
    if (roundType === "round1") {
      return [selectedMonth.date(13), selectedMonth.date(26)];
    }
    return [selectedMonth.date(27), selectedMonth.add(1, "month").date(12)];
  };

  const handlePrint = () => {
    const currentRange = getRange();
    const roundLabel = roundType === "round1" ? "13-26" : "27-12";
    exportFinanceReportPDF(filteredData, {
      title: "รายงานส่งการเงินตามรอบ",
      subtitle: currentRange
        ? `รอบ ${roundLabel} (${currentRange[0].format("DD/MM/YYYY")} - ${currentRange[1].format("DD/MM/YYYY")})`
        : "",
    });
  };

  const columns = columnsCase90(() => loadData()).filter(
    (col) => col.key !== "backToS1",
  );

  // แสดงเฉพาะเคสที่ flagHdpayment = true แล้วกรองด้วย "รอบการส่ง" (roundDate) ตามช่วงวันที่ของรอบที่เลือก
  const range = getRange();
  const paymentData = dataMainS4.filter((item) => item.flagHdpayment === true);
  const filteredData = range
    ? paymentData.filter((item) => {
        const roundDate = dayjs(item.roundDate);
        return (
          roundDate.valueOf() >= range[0].startOf("day").valueOf() &&
          roundDate.valueOf() <= range[1].endOf("day").valueOf()
        );
      })
    : paymentData;

  return (
    <>
      <Button
        color="primary"
        variant="outlined"
        icon={<FileTextOutlined />}
        onClick={showModal}
      >
        รายงานรับฝากค่างวด ตามรอบ
      </Button>
      <Modal
        open={open}
        onCancel={handleClose}
        footer={null}
        width={"80%"}
        maskClosable={false}
      >
        <Spin spinning={loading} tip="กำลังโหลด...">
          <Row>
            <Divider orientation="center">
              <b>รายงานรับฝากค่างวด ตามรอบ</b>
            </Divider>
            <Col span={24} style={{ marginBottom: "12px" }}>
              <DatePicker
                picker="month"
                style={{ width: "100%" }}
                value={selectedMonth}
                onChange={setSelectedMonth}
                format="MM/YYYY"
                placeholder="เลือกเดือน"
              />
            </Col>
            <Col span={24} style={{ marginBottom: "20px" }}>
              <Space>
                <Button
                  type={roundType === "round1" ? "primary" : "default"}
                  onClick={() => setRoundType("round1")}
                >
                  รอบ 13-26
                </Button>
                <Button
                  type={roundType === "round2" ? "primary" : "default"}
                  onClick={() => setRoundType("round2")}
                >
                  รอบ 27-12
                </Button>
              </Space>
            </Col>
            <Col span={24} style={{ marginBottom: "20px" }}>
              <TablePCMoble
                ColumnsCase90={columns}
                DataSourceTest={filteredData}
                rowKey="contno"
              />
            </Col>
            <Col span={24} style={{ textAlign: "right" }}>
              <Space>
                <Button
                  type="primary"
                  onClick={handlePrint}
                  disabled={!selectedMonth || !roundType}
                >
                  พิมพ์ PDF
                </Button>
                <Button onClick={handleClose}>ยกเลิก</Button>
              </Space>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
}
export default ModalPrintFinanceReport;
